module.exports = __webpack_public_path__ + "static/media/CBSE_image.6fce81f1.jpeg";